(function () {
    'use strict';
    var m = angular.module('common');
    m.directive('selectDropdown', ["path", "$timeout", function (path, $timeout) {
        return {
            restrict: 'A',
            replace: true,
            templateUrl: path('common').directive('select-dropdown').template(),
            scope: {
                options: '=selectDropdown',
                onChange: '&?'
            },
            link: function ($scope, element, attrs) {
                $scope.root = $scope;
                $scope.onChange = $scope.onChange || _.noop;
                $scope.selectionChanged = function (event, option) {
                    event.stopPropagation();
                    if (option && option.type === 'button') {
                        $timeout(function () {
                            $(window.document).trigger('click');    // this is to close dropdown
                        });
                    }
                    $scope.onChange({ option: option });
                };
                $scope.numberOptionChanged = function (option) {
                    var value = parseInt(option.state);
                    if (value !== '' && (!isFinite(option.min) || value >= option.min) && (!isFinite(option.max) || value <= option.max)) {
                        $scope.onChange({ option: option });
                    }
                };
                $scope.isAllSelected = function () {
                    return _($scope.options).every(function (option) {
                        return option.state;
                    });
                };
                $scope.selectAll = function () {
                    var newState = !$scope.isAllSelected();
                    _($scope.options).each(function (option) {
                        option.state = newState;
                    });
                    $scope.onChange();
                };
                $scope.isFiltered = function (option) {
                    return !option.alwaysShow && option.text.toLowerCase().indexOf(($scope.root.optionsFilter || '').toLowerCase()) == -1;
                };
            }
        };
    }]);
}());